import RequestAPI from "@/apis/components/RequestAPI.js";
import { MSEnum } from "@/commons/enumeration";

export default {
  debug: process.env.NODE_ENV !== 'production',
	namespaced: true,

  state: {
    requestList: [], // Danh sach yeu cau thanh toan
    selectedRow: null, // Dong duoc chon
  },

  getters: {
    /**
     * lấy dữ liệu yeu cau thanh toan
     * @param {*} state state
     * @returns dữ liệu tổng quan
     * @author: LMDuc(21/04/2022)
     */
    getRequestList(state) {
      return state.requestList;
    },
  },

  mutations: {
    setRequestData(state, data) {
      if (data && typeof(data) === "string") {
        data = JSON.parse(data);
      }

      state.requestList = data
    },

    updateRequestDataByID(state, data) {
      const requestList = state.requestList
      let request = requestList.PageData?.find(item => item.RequestID == data.RequestID)
      if(request){
        request.Status = data?.Status
      }
    },

    setRequestDetailByID(state, { data, requestID }) {
        if (state?.requestList?.PageData?.length) {
          state.requestList.PageData.map((request) => {
                if (request.RequestID === requestID) {
                    request.CompanyList = data.CompanyList;
                    request.TotalCompany = data.CompanyList?.length;
                    // Gán dòng được chọn
                    state.selectedRow = request;
                    return request;
                }
                else {
                    return request;
                }
            })
        }
    },
  },

  actions: {
    /**
     * Hàm lấy dữ liệu yeu cau thanh toan
     * NVHUY1 25/03/2022
     */
    getRequestData(context, payload) {
      let param = payload?.paging;
      let providerID = payload?.providerID;

      return new Promise((resolve, reject) => {
        RequestAPI.getRequestData(param)
          .then((res) => { 
          
            if (res.data?.Status && res.data?.Data) {
              let resData = res.data.Data;
              if (resData && typeof(resData) === "string") {
                resData = JSON.parse(resData);
              }
              context.commit('setRequestData', resData)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Hàm lấy dữ liệu yeu cau thanh toan chi tiet theo ID
     * LMDuc 25/03/2022
     */
    async getRequestDetailByID(context, requestID) {
        return new Promise((resolve, reject) => {
            RequestAPI.getRequestDetailByID(requestID)
              .then((res) => {
                if (res.data?.Status && res.data?.Data) {
                  let resData = res.data.Data;
                  if (resData && typeof(resData) === "string") {
                    resData = JSON.parse(resData);
                  }

                  context.commit('setRequestDetailByID', { data: resData,  requestID})
                  context.commit('updateRequestDataByID', resData)
                  resolve(true)
                }
              })
              .catch((err) => {
                reject(err)
              })
          })
    },
    async getCompany(budgetCode) {
      return new Promise((resolve, reject) => {
          RequestAPI.getCompany(budgetCode)
            .then((res) => {
              if (res.data?.Status && res.data?.Data) {
                let resData = res.data.Data;
                if (resData && typeof(resData) === "string") {
                  resData = JSON.parse(resData);
                }
                resolve(resData)
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
  },

    /**
     * Hàm xóa yêu cầu đang chờ xử lý
     * ndhuy1 26072022
     */
     async deleteWaittingRequest(context, requestID) {
      return new Promise((resolve, reject) => {
          RequestAPI.deleteWaittingRequest(requestID)
            .then((res) => {
              if (res.data?.Status && res.data?.Data) {
                let resData = res.data.Data;
                if (resData && typeof(resData) === "string") {
                  resData = JSON.parse(resData);
                }

                resolve(true)
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
  },

    /**
     * Gửi yêu cầu thiết lập
     * NVHUY1 18/05/2022
     */
     async sendRequestData(context, param) {
      return new Promise((resolve, reject) => {
        RequestAPI.sendRequestData(param)
            .then((res) => { 
              if (res.data?.Status && res.data?.Data) {
                context.commit('setRequestData', res.data.Data)
                resolve(true)
              } else if (!res.data?.Status) {
                reject(res.data?.ValidateInfo);
              }
            })
            .catch((err) => {
              reject(err)
            })
      })
    },
     /**
     * Cập nhật yêu cầu thiết lập
     * NVHUY1 18/05/2022
     */
     async updateRequestData(context, param) {
      return new Promise((resolve, reject) => {
        RequestAPI.updateRequestData(param)
            .then((res) => { 
              if (res.data?.Status && res.data?.Data) {
                context.commit('setRequestData', res.data.Data)
                resolve(true)
              } else if (!res.data?.Status) {
                reject(res.data?.ValidateInfo);
              }
            })
            .catch((err) => {
              reject(err)
            })
      })
    }
  }

}
